import { BaseReq, BaseResp } from "@/core/interface";

export class WorkPackageTableRecord extends BaseReq {
  uuid: string = ""; // 唯一ID
  workPackagesId: number;
  workPackagesBizNo: string;
  workPackagesName: string;
  sortValue: number;
  [props: string]: any;
}

export class WorkPackageTableReq extends BaseReq {
  records: WorkPackageTableRecord[] = [];
}
